import { patchSalesBOMJob, type PATCHSalesBOMJobResponse, type SalesBOMJobStatus } from '@services/productInventory';
import { useMutation } from '@tanstack/react-query';
import { useInvalidateQueries } from 'src/v2/shared/lib/hooks/useInvalidateQueries';

export interface UseUpdateSalesJobVars {
  runID: string;
  accountId: string;
  status: SalesBOMJobStatus;
  errors?: Array<{ source: string; message: string }>;
}

export const useUpdateSalesBOMJob = () => {
  const { invalidateContentProcessingJobsQueries, invalidateSalesBOMJobQuery } = useInvalidateQueries();

  return useMutation<PATCHSalesBOMJobResponse, Error, UseUpdateSalesJobVars>({
    mutationFn: (variables) => {
      const { runID, accountId, status, errors } = variables;

      return patchSalesBOMJob(runID, accountId, { status, errors });
    },
    onSuccess: async () => {
      await invalidateSalesBOMJobQuery();
      await invalidateContentProcessingJobsQueries();
    },
  });
};
